<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: 'neutral',
  },
  size: {
    type: String,
    default: 'sm',
  },
});

const sizeClassMap = {
  sm: 'px-2 py-0.5 text-[10px]',
  md: 'px-2.5 py-0.5 text-[10px]',
};

const variantClassMap = {
  neutral: 'bg-n-slate-1 text-n-slate-11',
  successSoft: 'bg-[#25d366]/10 text-[#128c7e]',
  successOutline: 'border border-[#25d366]/20 bg-[#25d366]/8 text-[#0f6b5a]',
  whiteSoft: 'bg-white/80 text-[#0f6b5a]',
  whiteOutline: 'border border-[#25d366]/20 bg-white/80 text-n-slate-11',
  whiteSolid: 'border border-[#25d366]/20 bg-white text-[#0f6b5a]',
};

const sizeClass = computed(() => sizeClassMap[props.size] || sizeClassMap.sm);
const variantClass = computed(
  () => variantClassMap[props.variant] || variantClassMap.neutral
);
</script>

<template>
  <span
    class="inline-flex items-center rounded-full font-medium"
    :class="[sizeClass, variantClass]"
  >
    {{ label }}
  </span>
</template>
